import { action } from 'typesafe-actions';

import { AppBarTypes } from './types';

// AppBar
export const setAppBarVisible = (payload: { visible: boolean }) =>
  action(AppBarTypes.SET_APPBAR_VISIBLE, payload);
